import s from '@/styles/components/ModalAlert.module.scss'
import { Button, ModalFrame, ModalBaseProps } from '@/components'

interface Props extends ModalBaseProps {
  title: string;
  detail?: string;
}

function ModalAlert(props: Props) {
  const { title, detail, onOk, okText, onCancel, cancelText, backdropRef } = props
  return (
    <ModalFrame
      content={
        <div className={s.wrap}>
          <h1 className={s.title}>{title}</h1>
          {detail && <p className={s.detail}>{detail}</p>}
        </div>
      }
      footer={
        <>
          {onCancel && (
            <Button variant={'secondary'} size={'xlarge'} className={s.button} onClick={onCancel}>
              {cancelText ?? '취소'}
            </Button>
          )}
          <Button variant={'primary'} size={'xlarge'} className={s.button} onClick={onOk}>
            {okText ?? '확인'}
          </Button>
        </>
      }
      contentCustomStyles={{ width: '312px' }}
      backdropRef={backdropRef}
    />
  )
}

ModalAlert.displayName = 'ModalAlert'
export { ModalAlert }
